export function createDeliveryPoller({
  readStatus,
  onSent,
  intervalMs = 10_000,
  setTimer = (callback, delay) => setTimeout(callback, delay),
  clearTimer = (timer) => clearTimeout(timer),
}) {
  let generation = 0;
  let timer = null;

  function stop() {
    generation += 1;
    if (timer !== null) {
      clearTimer(timer);
      timer = null;
    }
  }

  function schedule(runGeneration) {
    timer = setTimer(async () => {
      timer = null;
      try {
        const response = await readStatus();
        if (runGeneration !== generation) return;

        if (response.status === 200 && response.data?.delivery === 'sent') {
          onSent(response.data);
          return;
        }
        if (response.status === 200 || response.status >= 500) {
          schedule(runGeneration);
        }
      } catch {
        if (runGeneration === generation) schedule(runGeneration);
      }
    }, intervalMs);
  }

  return {
    start() {
      stop();
      schedule(generation);
    },
    stop,
  };
}
